import { createSelector } from 'reselect';

const selectLMSenrollments = (state: any) => state.lmsEnrollments;

export const selectLMSassignmentsCurrentItem = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.current
);

export const selectLMSenrollmentsListItems = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.list
);

export const selectLMSenrollmentsItemById = (itemId: any) =>
  createSelector(selectLMSenrollmentsListItems, (list) =>
    list.result.items.find((item: any) => item._id === itemId)
  );

export const selectLMSenrollmentsQueryItems = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.query
);

export const selectLMSenrollmentsCreatedItem = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.create
);

export const selectLMSenrollmentsUpdatedItem = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.update
);

export const selectLMSenrollmentsReadItem = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.read
);

export const selectLMSenrollmentsDeletedItem = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.delete
);

export const selectLMSenrollmentsSearchedItems = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.search
);

export const selectLMSenrollmentsItemsCount = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.count
);

export const selectLMSenrollmentsItemsFilter = createSelector(
  [selectLMSenrollments],
  (lmsEnrollments) => lmsEnrollments.filter
);
